import { createReducer, on } from "@ngrx/store";
import { LearnerOfflineActivityState, initialLearnerOfflineActivityState } from "./learner-offline-activity.state";
import { AddLearnerOfflineActivity, AddLearnerOfflineActivityError, AddLearnerOfflineActivitySuccess, EditLearnerOfflineActivity, EditLearnerOfflineActivityError, EditLearnerOfflineActivitySuccess, GetOfflineActivity, GetOfflineActivityError, GetOfflineActivitySkillSelection, GetOfflineActivitySkillSelectionError, GetOfflineActivitySkillSelectionSuccess, GetOfflineActivitySuccess, ResetAddLearnerOfflineActivityResult, ResetEditLearnerOfflineActivityResult, SetOfflineActivityNavigationRoute } from "./learner-offline-activity.actions";

export const LearnerOfflineActivityReducers = createReducer(
  initialLearnerOfflineActivityState,
  on(AddLearnerOfflineActivity, (state): LearnerOfflineActivityState => {
    return {
      ...state,
      addOfflineActResult: null,
      addOfflineActLoader: true,
      addOfflineActError: null,
    }
  }),
  on(AddLearnerOfflineActivitySuccess, (state, action): LearnerOfflineActivityState => {
    return {
      ...state,
      addOfflineActResult: action.result,
      addOfflineActLoader: false,
      addOfflineActError: null,
    }
  }),
  on(AddLearnerOfflineActivityError, (state, action): LearnerOfflineActivityState => {
    return {
      ...state,
      addOfflineActLoader: false,
      addOfflineActError: action.error,
    }
  }),
  on(ResetAddLearnerOfflineActivityResult, (state): LearnerOfflineActivityState => {
    return {
      ...state,
      addOfflineActResult: null,
    }
  }),
  on(EditLearnerOfflineActivity, (state): LearnerOfflineActivityState => {
    return {
      ...state,
      editOfflineActResult: null,
      editOfflineActLoader: true,
      editOfflineActError: null,
    }
  }),
  on(EditLearnerOfflineActivitySuccess, (state, action): LearnerOfflineActivityState => {
    return {
      ...state,
      editOfflineActResult: action.result,
      editOfflineActLoader: false,
      editOfflineActError: null,
    }
  }),
  on(EditLearnerOfflineActivityError, (state, action): LearnerOfflineActivityState => {
    return {
      ...state,
      editOfflineActLoader: false,
      editOfflineActError: action.error,
    }
  }),
  on(ResetEditLearnerOfflineActivityResult, (state): LearnerOfflineActivityState => {
    return {
      ...state,
      editOfflineActResult: null,
    }
  }),
  on(GetOfflineActivitySkillSelection, (state): LearnerOfflineActivityState => {
    return {
      ...state,
      skillSelection: null,
      skillSelectionLoader: true,
      skillSelectionError: null,
    }
  }),
  on(GetOfflineActivitySkillSelectionSuccess, (state, action): LearnerOfflineActivityState => {
    return {
      ...state,
      skillSelection: action.result,
      skillSelectionLoader: false,
      skillSelectionError: null,
    }
  }),
  on(GetOfflineActivitySkillSelectionError, (state, action): LearnerOfflineActivityState => {
    return {
      ...state,
      skillSelectionLoader: false,
      skillSelectionError: action.error,
    }
  }),
  on(GetOfflineActivity, (state): LearnerOfflineActivityState => {
    return {
      ...state,
      offlineActivity: null,
      offlineActivityLoader: true,
      offlineActivityError: null,
    }
  }),
  on(GetOfflineActivitySuccess, (state, action): LearnerOfflineActivityState => {
    return {
      ...state,
      offlineActivity: action.result,
      offlineActivityLoader: false,
      offlineActivityError: null,
    }
  }),
  on(GetOfflineActivityError, (state, action): LearnerOfflineActivityState => {
    return {
      ...state,
      offlineActivityLoader: false,
      offlineActivityError: action.error,
    }
  }),
  on(SetOfflineActivityNavigationRoute, (state, action): LearnerOfflineActivityState => {
      return {
          ...state,
          previousRoute: action.route,
      };
  }),
);